import { $, $$ } from 'utils/dom';
import Slider from 'modules/glide/glide';

const gridSliders = $$('.teaser-grid--is-slider');

if (gridSliders.length) {
  gridSliders.forEach(gridSlider => {
    const slider = new Slider($('.glide', gridSlider), {
      config: {
        type: 'slider',
        startAt: 0,
        perView: 3,
        controls: true,
        bound: true,
        gap: 45,
        breakpoints: {
          1199: {
            perView: 2,
          },
          767: {
            perView: 1,
          },
        },
      },
    });
    slider.init();
  });
}
